module.exports = __webpack_public_path__ + "img/doc_2.31a5730f.png";